import './main.css';
import { createApp } from 'vue';
import App from './App.vue';
const app = createApp(App);

import icon from '@/plugins/icon';
app.use(icon);

app.mount('#app');
